import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CustomFilterBody = _resolveComponent("CustomFilterBody");
  const _component_FilterItem = _resolveComponent("FilterItem");
  return _openBlock(), _createBlock(_component_FilterItem, {
    id: $props.filter_id,
    ref: `${$props.type}FilterItem`,
    icon: $props.icon,
    title: $options.getTitle,
    selectedTitle: $options.getSelectedTitle,
    class: _normalizeClass(`${$props.type}-filter`),
    selectedCount: $props.items?.filterState?.selectedCount,
    onClearAll: $options.handleClearAll,
    onHidden: $options.onHidden
  }, {
    body: _withCtx(() => [_createVNode(_component_CustomFilterBody, {
      title: $props.bodyTitle,
      selected: $props.items?.filterState?.selected,
      isModified: $props.items.isModified,
      isSearching: $props.items.isSearching,
      keyword: $props.items.keyword,
      list: $props.items.displayList,
      item_key: $props.item_key,
      item_name: $props.item_name,
      search_placeholder: $props.search_placeholder,
      onClear: $options.handleClear,
      onRestoreSearch: $options.onRestoreSearch,
      onSelect: $options.handleSelect,
      onSelectOnly: $options.handleSelectOnly,
      onSelectAll: _cache[0] || (_cache[0] = $event => $props.items.selectAll()),
      onDeselect: $options.handleDeselect,
      onApply: _cache[1] || (_cache[1] = $event => _ctx.$emit('apply')),
      onSearch: $options.handleSearch,
      onHidden: $options.onHidden,
      onCloseDropdown: _ctx.$refs?.[`${$props.type}FilterItem`]?.closeDropdown
    }, null, 8, ["title", "selected", "isModified", "isSearching", "keyword", "list", "item_key", "item_name", "search_placeholder", "onClear", "onRestoreSearch", "onSelect", "onSelectOnly", "onDeselect", "onSearch", "onHidden", "onCloseDropdown"])]),
    _: 1
  }, 8, ["id", "icon", "title", "selectedTitle", "class", "selectedCount", "onClearAll", "onHidden"]);
}